// Vacía localStorage al cerrar sesión, salvo lo que debe sobrevivir entre sesiones:
// la última versión de Novedades que vio cada usuario (novedades.vista.<userLogin>). Las
// tiendas cierran sesión cada turno; sin esto el punto de «sin leer» volvería siempre.
const KEEP_PREFIXES = ["novedades.vista."];

export function clearLocalStorageKeepingNovedades(storage: Storage = window.localStorage) {
  const keep: [string, string][] = [];
  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i);
    if (key && KEEP_PREFIXES.some((p) => key.startsWith(p))) {
      const value = storage.getItem(key);
      if (value !== null) keep.push([key, value]);
    }
  }
  storage.clear();
  keep.forEach(([k, v]) => storage.setItem(k, v));
}
